import Axios from "./axios";

const endpoint = "/api";

export default {
  /**
   * appSettingInfo table 조회
   * @returns
   */
  appSetting: () => Axios.get(`${endpoint}/getappsetting`),

  /** 월별 마감하기
   * @param {string} monthDate // "2025-04"
   * @param {string} closeYn // "Y" 마감, "N" 마감해제
   * @param {number} constructionId // 현장 번호
   */
  closeMonth: async (monthDate, closeYn, constructionId) => {
    const res = Axios.post(`${endpoint}/close/month`, {
      monthDate,
      closeYn,
      constructionId,
    });
    return res;
  },
};
